import request from '@/utils/request';
import { fileService } from "@/api/common/file-utils";

export const exportExcel = (id) => {
    return request({
        url: `/sensory-template/${id}/export`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        fullResponse: true,
        responseType: 'blob',
    }).then(resp => fileService.respToFile(resp));
};

export const getTemplateDetail = (templateId) => {
    return request({
        url: `/sensory-template/${templateId}`,
        method: 'get',
    });
};

export const getTemplateByFiveBitCode = (fiveBitCode) => {
    return request({
        url: `/sensory-template/getDetailByFiveBitCode`,
        method: 'get',
        params: {
            fiveBitCode: fiveBitCode
        }
    });
};
export const getDetailByTemplateId = (ttSensoryTemplateId) => {
    return request({
        url: `/sensory-template/getDetailByTemplateId`,
        method: 'get',
        params: {
            templateId: ttSensoryTemplateId
        }
    });
};
export default {
    exportExcel: exportExcel,
    getTemplateDetail: getTemplateDetail,
    getTemplateByFiveBitCode: getTemplateByFiveBitCode,
    getDetailByTemplateId: getDetailByTemplateId,
}
export const templateList = (data) => {
    return request({
        url: '/sensory-template/pageList',
        method: 'post',
        data: data
    });
};
export const saveTemplate = (data) => {
    return request({
        url: '/sensory-template',
        method: 'post',
        data: data
    });
};
export const getTemplateDetails = (data) => {
    return request({
        url: '/sensory-template/' + data,
        method: 'get',
    });
}

export const approvalPass = (id, data) => {
    return request({
        url: '/sensory-template/' + id,
        method: 'PUT',
        params: data,
    });
};
export const copyInit = (id) => {
    return request({
        url: '/sensory-template/' + id + '/copy',
        method: 'post',
    });
};
export const activeTemplate = (templateId, status) => {
    return request({
        url: `/sensory-template/activeTemplate/${templateId}/${status}`,
        method: 'get',
    });
};
export const deleteTemplateForDraft = (templateId) => {
    return request({
        url: `/sensory-template/deleteTemplateForDraft/${templateId}`,
        method: 'get',
    });
};